import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_PUBLIC_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_PUBLIC_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error('Missing Supabase environment variables');
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey);

export type Member = {
  id: string;
  user_id: string;
  name: string;
  email: string;
  phone: string | null;
  points: number;
  total_spent: number;
  member_level: 'regular' | 'silver' | 'gold';
  created_at: string;
  updated_at: string;
};

export type PointTransaction = {
  id: string;
  member_id: string;
  points: number;
  type: 'earn' | 'redeem' | 'bonus';
  description: string | null;
  order_id: string | null;
  created_at: string;
};
